<template>
  <div class="collapse-item-warp">
    <div
      class="collapse-item-head"
      :class="{ active: value }"
      @click="onChange"
    >
      <span class="collapse-item-title">{{ item.pTitle }}</span>
      <span class="collapse-item-icon" :class="{ 'is-open': value }">›</span>
    </div>
    <div class="collapse-item-body" v-show="value">
      {{ item.pContent }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onChange() {
      this.$emit("input", !this.value)
    }
  }
}
</script>

<style lang="less">
/* 对齐 App help_item.dart：浅紫底卡片，无边框，主题色右箭头 */
.collapse-item-warp {
  margin: 0 24px 18px;
  background: #f8f6fc;
  border-radius: 18px;
  overflow: hidden;
}

.collapse-item-head {
  display: flex;
  align-items: center;
  padding: 20px 24px;
  font-size: 28px;
  color: #000;
  font-family: "Montserrat-SemiBold", sans-serif;
  font-weight: 400;
  line-height: 1.4;
  cursor: pointer;
}

.collapse-item-head.active {
  font-weight: 600;
}

.collapse-item-title {
  flex: 1;
  padding-right: 16px;
  word-break: break-word;
}

.collapse-item-icon {
  flex-shrink: 0;
  display: block;
  width: 36px;
  height: 36px;
  font-size: 40px;
  line-height: 36px;
  text-align: center;
  color: #ff8800;
  font-weight: 600;
  transition: transform 0.2s;
}

.collapse-item-icon.is-open {
  transform: rotate(90deg);
}

.collapse-item-body {
  padding: 0 60px 20px 24px;
  font-size: 24px;
  color: #000;
  line-height: 1.5;
  word-break: break-word;
}
</style>
